import { makeStyles } from '@fluentui/react-components';

export const useNoLocationsStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  imageContainer: {
    flexGrow: 1,
    flexBasis: '0',
    maxHeight: '210px',
    width: '100%',
    overflowY: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    backgroundColor: '#FAFAFA',
  },
  image: {
    maxHeight: '148px',
  },
  title: {
    marginTop: '16px',
  },
});

